export default __webpack_public_path__ + "static/1a34942e-33ed-43bb-b229-7460d55b49f7-30a8c495a19e56b2fff1192bfdf07450.woff2";